import styled from 'styled-components';

import { Button } from '@components';
import { flexAsColumn } from '@components/Styled/mixins';

const SubmitButton = styled(Button)`
  width: ${({ theme }) => `${theme.spacing(16)}`};
`;

const ParagraphGroup = styled.div`
  ${flexAsColumn(2)};
`;

const SupportInfoWrapper = styled.div`
  ${flexAsColumn(6)};
`;

const InactiveAccountLockWrapper = styled.div`
  ${flexAsColumn(4)};

  text-align: center;
  align-items: center;
  justify-content: center;
  height: inherit;
  margin-top: ${({ theme }) => theme.spacing(4)};
`;

export {
  InactiveAccountLockWrapper,
  ParagraphGroup,
  SubmitButton,
  SupportInfoWrapper
};
